import {Routes} from '@angular/router';
import {AuthGuard} from '../../core/security/auth-guard.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {ModulesEnum} from '../../core/security/modules.enum';
import {MenuGroupEnum} from '../../core/security/menu-group.enum';
import {CustomFieldsListComponent} from './list/list.component';
import {CustomFieldEditComponent} from './custom-field-edit/custom-field-edit.component';

export const routes: Routes = [
  {
    path: 'list',
    component: CustomFieldsListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      otherMenuGroups: [MenuGroupEnum.ContactGroup],
      package: ModulesEnum.CustomFieldsModule,
      permissions: [RolesEnum.CustomFieldsView, RolesEnum.CustomFieldsEdit, RolesEnum.CustomFieldsDelete],
      meta: {
        title: 'Custom Fields',
        override: true,
        description: 'Custom Fields Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'view_list',
        order: 3
      }
    }
  },
  {
    path: 'details',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: ':id',
            children: [
              {
                path: 'edit',
                component: CustomFieldEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.SettingsGroup,
                  package: ModulesEnum.CustomFieldsModule,
                  permissions: [RolesEnum.CustomFieldsEdit, RolesEnum.CustomFieldsDelete],
                  meta: {
                    title: 'Custom Field Edit',
                    override: true,
                    description: 'Edit Custom Fields Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'view_list',
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
];
